export function parseQueryParam (queryParam, url) {
  const queryParams = url.substring(url.lastIndexOf(`${queryParam}=`)+ queryParam.length + 1);
  return queryParams.substring(0, queryParams.indexOf('&') > -1 ? queryParams.indexOf('&') : queryParams.length);
}
 export function parseUrlParam (urlParam, url) {
  const urlParams = url.substring(url.lastIndexOf(`/${urlParam}/`)+ urlParam.length + 2);
  return urlParams.substring(0, urlParams.indexOf('/') > -1 ? urlParams.indexOf('/') : urlParams.length);
}



// WEBPACK FOOTER //
// ./src/utils/index.js